export const maskEmail = (email) => {
  if (!email || typeof email !== 'string') return ''

  const parts = email.split('@')
  if (parts.length !== 2 || !parts[0] || !parts[1]) return email

  const [local, domain] = parts
  return `${local.charAt(0)}*****@${domain}`
}
